module.exports = __webpack_public_path__ + "img/9.6e7bb524.jpg";